module.exports = __webpack_public_path__ + "img/icon-sleep.826d2bc2.png";